<template>
  <div>
    <form class="user-form login package" v-on:submit.prevent="saveProfile">
      <h3>Past payments</h3>
      <div v-for="payment in item.allPayments" v-if="payment.id!=item.activePayment.id">
        <div style="display: flex; margin-bottom: 10px">
          <div>
            <label style="position: relative; z-index: 1; text-align: center;">Start date</label>
            <datepicker style="margin-top: -20px; padding: 20px 0 0; text-align: center;" v-model="payment.rangeStartDate" />
          </div>
          <div style="margin-left: 10px">
            <label style="position: relative; z-index: 1; text-align: center;">End date</label>
            <datepicker style="margin-top: -20px; padding: 20px 0 0; text-align: center;" v-model="payment.rangeEndDate" />
          </div>
          <div style="margin-left: 10px">
            <button class="main" style="width: 30px; height: 20px; font-size: 1.3em; line-height: 20px; margin-top: -1px;" v-on:click.prevent="updatePayment(payment)">✓</button>
            <button class="main" style="width: 30px; height: 20px; font-size: 1.3em; line-height: 20px; margin-top: 5px; background: #e03020" v-on:click.prevent="deletePayment(payment)">×</button>
          </div>
        </div>
      </div>
      <div v-if="!item.activePayment">
        <div class="none">(no active package)</div>
      </div>
      <div v-else>
        <h3>Current payment</h3>
        <div class="name">{{ item.activePayment.package.name }}</div>
        <div style="display: flex; margin-bottom: 10px">
          <div>
            <label style="position: relative; z-index: 1; text-align: center;">Start date</label>
            <datepicker style="margin-top: -20px; padding: 20px 0 0; text-align: center;" v-model="item.activePayment.rangeStartDate" />
          </div>
          <div style="margin-left: 10px">
            <label style="position: relative; z-index: 1; text-align: center;">End date</label>
            <datepicker style="margin-top: -20px; padding: 20px 0 0; text-align: center;" v-model="item.activePayment.rangeEndDate" />
          </div>
        </div>
        <button class="main">Activate &amp; Send email</button>
      </div>
    </form>
  </div>
</template>
<script>
import api from './api';
import moment from 'moment';

export default {
  props: ["item"],
  data: ()=>({
  }),
  computed: {
  },
  methods: {
    formatDate(date, format) {
      if (!date)
        return "";
      return moment(date).format(format);
    },
    async saveProfile() {
      await api.update("Payment", this.item.activePayment.id, {
        userid: this.item.id,
        rangeEndDate: this.item.activePayment.rangeEndDate,
        rangeStartDate: this.item.activePayment.rangeStartDate,
      });
      this.$emit("save");
    },
    async updatePayment(payment) {
      await api.update("Payment", payment.id, {
        rangeEndDate: payment.rangeEndDate,
        rangeStartDate: payment.rangeStartDate,      
      });
      appNotifications.show("Payment updated", "success");
    },
    async deletePayment(payment) {
      if (!confirm("Are you sure?"))
        return;
      await api.delete("Payment", payment.id);
      appNotifications.show("Payment deleted", "success");
      var index=this.item.allPayments.findIndex((a)=>a.id==payment.id);
      if (index!=-1)
        this.item.allPayments.splice(index, 1);
    },
  },
  created() {
  },
}
</script>
